import React from 'react';
import { motion } from 'framer-motion';
import { Quotes } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';

const testimonials = [
  {
    id: 1,
    name_fr: "Ir. Jean-Pierre Kabongo",
    name_en: "Ir. Jean-Pierre Kabongo",
    role_fr: "Directeur des Infrastructures — Province du Kasaï-Central",
    role_en: "Director of Infrastructure — Kasai-Central Province",
    text_fr: "JKM Engineering a démontré un professionnalisme exemplaire sur le projet de drainage urbain de Kananga. Les délais ont été respectés à 100%, la qualité des ouvrages est irréprochable, et leur laboratoire géotechnique nous a fourni des données fiables qui ont optimisé le dimensionnement des fondations. Un partenaire technique de confiance.",
    text_en: "JKM Engineering demonstrated exemplary professionalism on the Kananga urban drainage project. Deadlines were met 100%, the quality of works is impeccable, and their geotechnical laboratory provided reliable data that optimized foundation sizing. A trusted technical partner.",
  },
  {
    id: 2,
    name_fr: "Dr. Marie-Claire Tshilanda",
    name_en: "Dr. Marie-Claire Tshilanda",
    role_fr: "Coordinatrice WASH — UNICEF RDC",
    role_en: "WASH Coordinator — UNICEF DRC",
    text_fr: "Le programme de forage hydraulique mené avec JKM Engineering a dépassé nos attentes. Sur 10 puits prévus, 10 ont été livrés avec des débits conformes aux spécifications techniques. Leur approche intégrant le pompage solaire garantit la durabilité des installations et réduit les coûts de maintenance pour les communautés bénéficiaires.",
    text_en: "The hydraulic drilling program conducted with JKM Engineering exceeded our expectations. Of 10 planned wells, all 10 were delivered with flow rates meeting technical specifications. Their approach integrating solar pumping ensures installation sustainability and reduces maintenance costs for beneficiary communities.",
  },
  {
    id: 3,
    name_fr: "M. Patrick Mbuyi",
    name_en: "Mr. Patrick Mbuyi",
    role_fr: "Directeur Régional — BCC Kananga",
    role_en: "Regional Director — BCC Kananga",
    text_fr: "L'aménagement de notre complexe par JKM Engineering a transformé l'image de notre institution. Les travaux de pavage, l'éclairage et le drainage ont été réalisés avec une précision remarquable, le tout livré avec 2 semaines d'avance sur le planning initial. Nous recommandons vivement JKM Engineering pour tout projet d'infrastructure.",
    text_en: "The development of our complex by JKM Engineering transformed our institution's image. The paving, lighting, and drainage works were carried out with remarkable precision, all delivered 2 weeks ahead of the initial schedule. We strongly recommend JKM Engineering for any infrastructure project.",
  },
];

export const TestimonialsSection = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-24 lg:py-32 bg-[#F8FAFC]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="text-center mb-16">
          <p className="text-[#FF6B00] text-xs sm:text-sm font-medium uppercase tracking-[0.2em] mb-4">{t.testimonials.title}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1320] tracking-tight" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{t.testimonials.subtitle}</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="bg-white border border-[#E2E8F0] p-8 flex flex-col justify-between hover:border-[#FF6B00]/20 transition-colors"
            >
              <div>
                <Quotes size={32} className="text-[#FF6B00]/20 mb-4" weight="fill" />
                <p className="text-base text-[#475569] leading-relaxed mb-6" style={{ fontFamily: "'Manrope', sans-serif" }}>
                  "{language === 'fr' ? testimonial.text_fr : testimonial.text_en}"
                </p>
              </div>
              <div className="flex items-center gap-4 pt-6 border-t border-[#E2E8F0]">
                <div className="w-12 h-12 bg-[#0B1320] flex items-center justify-center text-white font-bold text-sm">
                  {(language === 'fr' ? testimonial.name_fr : testimonial.name_en).split(' ').slice(-2).map(n => n[0]).join('')}
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0B1320]">{language === 'fr' ? testimonial.name_fr : testimonial.name_en}</p>
                  <p className="text-xs text-[#94A3B8]">{language === 'fr' ? testimonial.role_fr : testimonial.role_en}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
